<script lang="ts" setup>
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { useTheme } from 'vuetify'

const props = defineProps<{
  firstName?: string | null
  lastName?: string | null
  customClass?: string
}>()

const userStore = useUserStore()
const theme = useTheme()
const user = computed(() => userStore)

const backgroundColors = computed(() => {
  const colors = theme.current.value.colors
  return [
    colors['avatar-0'],
    colors['avatar-1'],
    colors['price-plan-gold'],
    colors['avatar-3'],
    colors['avatar-4'],
    colors['avatar-5'],
    colors['avatar-6'],
    colors['avatar-7'],
    colors['avatar-8'],
    colors['avatar-9'],
  ]
})

const getFullName = computed(() => {
  if (props.firstName && props.lastName) return props.firstName + props.lastName
  if (user.value?.firstName && user.value?.lastName) return user.value.firstName + user.value.lastName
  return ''
})

const initials = computed(() => {
  if (props.firstName && props.lastName) return `${props.firstName[0]}${props.lastName[0]}`
  if (user.value?.firstName && user.value?.lastName) return `${user.value.firstName[0]}${user.value.lastName[0]}`
  return ''
})

const getBackground = computed(() => {
  if (!getFullName.value.length) return theme.current.value.colors['avatar-0'] as string

  let hash = 0
  for (let i = 0; i < getFullName.value.length; i++) {
    hash = (hash << 5) - hash + getFullName.value.charCodeAt(i)
    hash |= 0
  }

  return backgroundColors.value[Math.abs(hash % 10)]
})
</script>

<template>
  <div :class="['avatar', props.customClass]" :style="`background:${getBackground}`">
    {{ initials }}
  </div>
</template>

<style lang="sass">

$ns: avatar

.#{$ns}
  position: relative
  display: flex
  align-items: center
  justify-content: center
  width: 40px
  height: 40px
  border-radius: 50%
  background-color: $c-avatar-0
  color: $c-white
  font-weight: bold
</style>
